<template>
  <v-col cols="3">
    <v-select
      hide-details
      outlined
      dense
      item-text="humanReadableId"
      item-value="id"
      v-model="selectedFleet"
      :items="fleets"
      @change="onChange"
    >
    </v-select>
  </v-col>
</template>

<script>
import { bookingChannelComputed } from '../mixins/bookingChannel.mixins';

export default {
  name: 'fleetSelector',
  mixins: [
    bookingChannelComputed,
  ],
  data() {
    return {
      selectedFleet: '',
    };
  },
  methods: {
    onChange(fleetId) {
      if (fleetId) {
        this.$store.dispatch('fleets/setSelectedFleet', fleetId);
      } else {
        this.$store.dispatch('fleets/clearSelectedFleet');
      }
    },
  },
  beforeMount() {
    const { fleetId } = this.$route.query;
    if (this.fleets && fleetId && this.fleets.find(fleet => fleet.id === fleetId)) {
      this.selectedFleet = fleetId;
    } else if (this.fleets && this.fleets.length) {
      this.selectedFleet = this.fleets[0].id;
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
